export function arryIsNonNullish<T>(items: T[]) {
  return items.every((item) => item !== null && item !== undefined);
}
